import Typography from "@mui/material/Typography";
import {makeStyles} from "@mui/styles";
import React from "react";

import Container from "Components/Container.js";
import Image from "Components/Image.js";
import String from "Components/String.js";

import scss from "./PoweredByHops.module.scss";

const useStyles = makeStyles(theme => ({
	container: {
		borderColor: theme.palette.grey[300],
		borderRadius: theme.spacing(0.5),
		borderStyle: "solid",
		borderWidth: "1px",
		backgroundColor: theme.palette.grey[100],
		padding: theme.spacing(1)
	}
}));

const PoweredByHops = ({color, gap, inlineChild, maxTextWidth, label, str}) => {

	const classes = useStyles();

	return (
		<Container alignItems="center" className={classes.container} columns="1fr 4.5rem" gap={(gap || 4)}>
			<Container maxWidth={maxTextWidth}>
				<span>
					<Typography color={(color || "textSecondary")} display="inline">
						{label}
					</Typography>
					{(inlineChild && <span>&nbsp;</span>)}
					{inlineChild}
				</span>
				{(str && <String color={(color || "textSecondary")} str={str} />)}
			</Container>
			<a
				className={scss.logo}
				href="https://www.hops.org.uk"
				rel="noopener noreferrer"
				target="_blank"
				title="Visit HOPS">
				<Image
					alt="HOPS logo"
					noError={true}
					noLoader={true}
					objectFit="contain"
					src="/assets/hops.png" />
			</a>
		</Container>
	);
};

export default PoweredByHops;
